'use client';
var classes = {"root":"m-7cda1cd6","root--default":"m-44da308b","root--contrast":"m-e3a01f8","label":"m-1e0e6180","remove":"m-ae386778","group":"m-1dcfd90b"};

export { classes as default };
//# sourceMappingURL=Pill.module.css.mjs.map
